// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"226c8d25","69":"fbd31174","288":"5ddb2487","430":"4ca54927","477":"dc516339","680":"bb534ad7","690":"492fb88f","734":"327d95f4"}[chunkId] + ".chunk.js";
};